module.exports = __webpack_public_path__ + "static/media/Setting_Config_banner.1d22fcec.png";